import './index.sass'

export default function Page404() {
    return (
        <div className="page-404">
        </div>
    )
}